import React from 'react';

// Something that happened in the app ("You added ... to your plan"),
// rendered as a quiet divider note. The text is the event's owner_note,
// written for the owner; an app event's content is written for the coach
// and is never shown.
export default function AppEventNote({ note }) {
  return (
    <div className="flex items-center gap-3 font-label text-[10px] uppercase tracking-[0.08em] text-muted-foreground">
      <span className="flex-1 h-px bg-border" />
      <span className="max-w-[70%] text-center">{note}</span>
      <span className="flex-1 h-px bg-border" />
    </div>
  );
}
